import styles from "./WishlistNotifications.module.scss";
import { CardComponentProps } from "@~/types/types";

export function WishlistNotifications({
  product,
}: Pick<CardComponentProps, "product">) {
  const hasPriceDropNotification = !!product.options?.wishlist_priceDrop;
  const hasBackInStockNotification = !!product.options?.wishlist_backInStock;
  const hasLowStockNotification = !!product.options?.wishlist_lowStock;
  const hasWishlistNotifications =
    hasPriceDropNotification ||
    hasBackInStockNotification ||
    hasLowStockNotification;

  if (!hasWishlistNotifications) {
    return null;
  }

  return (
    <div
      data-component="pcl-WishlistNotifications"
      className={styles.wishlistNotifications}
      data-testid="wishlist-notifications"
    >
      {hasPriceDropNotification && (
        <span
          className={styles.wishlistNotificationItem}
          data-testid="wishlist-notification-price-drop"
        >
          Price drop
        </span>
      )}
      {hasBackInStockNotification && (
        <span
          className={styles.wishlistNotificationItem}
          data-testid="wishlist-notification-back-in-stock"
        >
          Back in stock
        </span>
      )}
      {hasLowStockNotification && (
        <span
          className={styles.wishlistNotificationItem}
          data-testid="wishlist-notification-low-stock"
        >
          Low stock
        </span>
      )}
    </div>
  );
}
